import { userReducerConstant } from "../reducerConstant";

const initialState = {
  isLoggedIn: false,
  userData: {},
  userPosts: [],
  followers: [],
  followings: [],
  followersCount: {
    following: 0,
    followers: 0,
  },
  postsCount: 0,
  reelsCount: 0,
  followerSuggestion: [],
  imagePosts: {
    data: [],
    links: {},
    meta: {},
  },
  reels: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case userReducerConstant.LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        userData: { ...action.payload },
      };
    case userReducerConstant.LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
        userData: {},
      };
    case userReducerConstant.GET_FOLLOWERS:
      return {
        ...state,
        followers: action.payload,
      };
    case userReducerConstant.GET_FOLLOWINGS:
      return {
        ...state,
        followings: action.payload,
      };
    case userReducerConstant.SET_FOLLOWERSFOLLOWINGS_COUNT:
      return {
        ...state,
        followersCount: { ...action.payload },
      };
    case userReducerConstant.SET_USER_ACTIVITY_COUNT:
      return {
        ...state,
        followersCount: {
          ...state.followersCount,
          followingCount: action.payload.following,
        },
        postsCount: action.payload.post,
        reelsCount: action.payload.reels,
      };
    case userReducerConstant.GET_FOLLOWERS_SUGGESTION:
      return {
        ...state,
        followerSuggestion: { ...action.payload },
      };
    case userReducerConstant.SET_IMAGE_POSTS:
      return {
        ...state,
        imagePosts: { ...action.payload },
      };
    case userReducerConstant.GET_REELS:
      return {
        ...state,
        reels: [...action.payload],
      };
    default:
      return state;
  }
};

export default userReducer;
